<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1100px"
    :in-dialog="inDialog"
    @closed="onClosed"
  >
    <list ref="list" common :show-checkbox="multiple" :show-other="showOther" :st-params="stParams" is-dialog :checkbox-fixed="false">
      <template #column>
        <slot name="column" />
        <el-table-column
          label="操作"
          align="center"
          width="60"
          fixed="right"
          v-if="selectable&&!multiple"
        >
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button
          type="primary"
          @click="selectMultiple"
          v-if="selectable&&multiple"
          size="small"
        >选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "学生列表",
    },
    showClass: {
      type: Boolean,
      default: false,
    },
    showOther: {
      type: Boolean,
      default: false,
    },
    stParams: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    showForm() {
      this.$nextTick(() => {
        this.$refs.list.$refs.list.showForm = true;
      })
    },
    getDataWithClass(TermId, TeacherId, StayQualification) {
      this.$refs.list.getGrade(TermId, TeacherId, StayQualification);
    },
    onClosed() {
      this.$refs.list.reset();
    },
  },
};
</script>